import { SxProps, Theme } from "@mui/material";

export const PAGE_TWO_STYLES = {
  sectionTitle: {
    backgroundColor: "#63B4FF33",
    color: "#2979C3",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
  } as SxProps<Theme>,
  label: {
    fontWeight: 400,
    marginLeft: "0",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
  } as SxProps<Theme>,
  textField: {
    width: "100%",
    maxWidth: "300px",
  } as SxProps<Theme>,
  select: {
    maxWidth: "300px",
    width: "100%",
  } as SxProps<Theme>,
  gridPadding: {
    paddingTop: "10px",
  } as SxProps<Theme>,
  gridItem: {
    padding: "0px",
  } as SxProps<Theme>,
  container: {
    padding: "20px",
    width: "100%",
  } as SxProps<Theme>,
};
